import type { IdeaSource } from './types';

/** Ideenbuch 31–40: eggs, fritters, sweet dinners, salads and fish. */
export const IDEAS_4: IdeaSource[] = [
  {
    id: 'shakshuka',
    minutes: 25,
    tags: ['veggie'],
    de: {
      title: 'Shakshuka',
      ingredients: [
        '6 Eier',
        '2 Dosen gehackte Tomaten',
        '2 Paprika, gewürfelt',
        '1 Zwiebel, gewürfelt',
        '1 TL Kreuzkümmel',
        '1 TL Paprikapulver',
        '100 g Feta',
        'Fladenbrot',
      ],
      steps: [
        'Zwiebel und Paprika 5 Minuten in einer großen Pfanne andünsten.',
        'Gewürze kurz mitrösten, Tomaten dazugeben und 10 Minuten köcheln lassen.',
        'Sechs Mulden drücken, die Eier hineinschlagen und zugedeckt 6 Minuten stocken lassen.',
        'Mit Feta bestreuen und mit Fladenbrot servieren.',
      ],
      kidsTip: 'Brot zum Tunken ist das Beste daran.',
    },
    en: {
      title: 'Shakshuka',
      ingredients: [
        '6 eggs',
        '2 cans chopped tomatoes',
        '2 peppers, diced',
        '1 onion, diced',
        '1 tsp cumin',
        '1 tsp paprika',
        '100 g feta',
        'Flatbread',
      ],
      steps: [
        'Soften the onion and peppers in a large pan for 5 minutes.',
        'Toast the spices briefly, add the tomatoes and simmer for 10 minutes.',
        'Make six hollows, crack the eggs into them and cook covered for 6 minutes.',
        'Sprinkle with feta and serve with flatbread.',
      ],
      kidsTip: 'Bread for dipping is the best part.',
    },
  },
  {
    id: 'scrambled-eggs-bread',
    minutes: 15,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Rührei mit Brot und Gemüsesticks',
      ingredients: [
        '8 Eier',
        '100 ml Milch',
        '1 EL Butter',
        'Schnittlauch',
        '1 Vollkornbrot',
        '2 Möhren',
        '1 Gurke',
        '1 Paprika',
      ],
      steps: [
        'Eier mit Milch, Salz und Pfeffer verquirlen.',
        'Butter in einer Pfanne schmelzen, Eier hineingeben und bei kleiner Hitze 4 Minuten langsam stocken lassen.',
        'Gemüse in Sticks schneiden, Brot aufschneiden.',
        'Rührei mit Schnittlauch bestreuen und alles zusammen servieren.',
      ],
      kidsTip: 'Ein Abendbrot, das in 15 Minuten auf dem Tisch steht.',
    },
    en: {
      title: 'Scrambled eggs with bread and veggie sticks',
      ingredients: [
        '8 eggs',
        '100 ml milk',
        '1 tbsp butter',
        'Chives',
        '1 wholemeal loaf',
        '2 carrots',
        '1 cucumber',
        '1 pepper',
      ],
      steps: [
        'Whisk the eggs with the milk, salt and pepper.',
        'Melt the butter in a pan, add the eggs and let them set slowly over low heat for 4 minutes.',
        'Cut the vegetables into sticks and slice the bread.',
        'Sprinkle the eggs with chives and serve everything together.',
      ],
      kidsTip: 'A supper that is on the table in 15 minutes.',
    },
  },
  {
    id: 'potato-pancakes',
    minutes: 40,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Kartoffelpuffer mit Apfelmus',
      ingredients: [
        '1 kg festkochende Kartoffeln',
        '1 Zwiebel',
        '2 Eier',
        '3 EL Mehl',
        '6 EL Öl zum Braten',
        '1 Glas Apfelmus',
      ],
      steps: [
        'Kartoffeln und Zwiebel schälen und fein reiben, in einem Tuch kräftig ausdrücken.',
        'Mit Eiern, Mehl und Salz vermengen.',
        'Je einen Esslöffel Teig in heißes Öl geben, flach drücken und von jeder Seite 4 Minuten knusprig braten.',
        'Auf Küchenpapier abtropfen lassen und mit Apfelmus servieren.',
      ],
      kidsTip: 'Puffer im Ofen bei 100 °C warm halten, bis alle fertig sind.',
    },
    en: {
      title: 'Potato fritters with apple sauce',
      ingredients: [
        '1 kg waxy potatoes',
        '1 onion',
        '2 eggs',
        '3 tbsp flour',
        '6 tbsp oil for frying',
        '1 jar apple sauce',
      ],
      steps: [
        'Peel and finely grate the potatoes and onion and squeeze them hard in a tea towel.',
        'Mix with the eggs, flour and salt.',
        'Drop tablespoons of the mix into hot oil, flatten and fry for 4 minutes on each side until crisp.',
        'Drain on kitchen paper and serve with apple sauce.',
      ],
      kidsTip: 'Keep the fritters warm in the oven at 100 °C until all are done.',
    },
  },
  {
    id: 'rice-pudding',
    minutes: 40,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Milchreis mit Kirschen',
      ingredients: [
        '250 g Milchreis',
        '1 l Milch',
        '2 EL Zucker',
        '1 Päckchen Vanillezucker',
        '1 Glas Sauerkirschen',
        '1 EL Speisestärke',
        'Zimt und Zucker',
      ],
      steps: [
        'Milch mit Zucker und Vanillezucker aufkochen, Reis einrühren.',
        'Bei kleiner Hitze 30 Minuten quellen lassen, dabei ab und zu umrühren.',
        'Kirschen mit Saft erhitzen, Stärke in wenig Wasser anrühren und unterrühren.',
        'Milchreis mit Kirschen und Zimt und Zucker servieren.',
      ],
      kidsTip: 'Ein süßes Abendessen ab und zu macht alle froh.',
    },
    en: {
      title: 'Rice pudding with cherries',
      ingredients: [
        '250 g pudding rice',
        '1 l milk',
        '2 tbsp sugar',
        '1 sachet vanilla sugar',
        '1 jar sour cherries',
        '1 tbsp cornflour',
        'Cinnamon sugar',
      ],
      steps: [
        'Bring the milk to the boil with the sugar and vanilla sugar and stir in the rice.',
        'Let it swell over low heat for 30 minutes, stirring now and then.',
        'Heat the cherries with their juice, mix the cornflour with a little water and stir it in.',
        'Serve the rice pudding with the cherries and cinnamon sugar.',
      ],
      kidsTip: 'A sweet supper now and then makes everyone happy.',
    },
  },
  {
    id: 'french-toast',
    minutes: 20,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Arme Ritter',
      ingredients: [
        '8 Scheiben Toastbrot oder altes Weißbrot',
        '3 Eier',
        '250 ml Milch',
        '1 Päckchen Vanillezucker',
        '2 EL Butter',
        'Zimt und Zucker',
        '2 Äpfel',
      ],
      steps: [
        'Eier, Milch und Vanillezucker verquirlen.',
        'Brotscheiben kurz darin wenden.',
        'In Butter von jeder Seite 2 Minuten goldbraun braten.',
        'Mit Zimt und Zucker und Apfelschnitzen servieren.',
      ],
      kidsTip: 'Gut für Brot, das sonst weg müsste.',
    },
    en: {
      title: 'French toast',
      ingredients: [
        '8 slices bread or stale white bread',
        '3 eggs',
        '250 ml milk',
        '1 sachet vanilla sugar',
        '2 tbsp butter',
        'Cinnamon sugar',
        '2 apples',
      ],
      steps: [
        'Whisk the eggs, milk and vanilla sugar.',
        'Dip the bread slices in it briefly.',
        'Fry in the butter for 2 minutes on each side until golden.',
        'Serve with cinnamon sugar and apple slices.',
      ],
      kidsTip: 'Good for bread that would otherwise go to waste.',
    },
  },
  {
    id: 'pasta-salad',
    minutes: 30,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Nudelsalat',
      ingredients: [
        '400 g Fusilli',
        '250 g Cherrytomaten',
        '1 Gurke',
        '1 Paprika',
        '125 g Mozzarella-Kugeln',
        '4 EL Olivenöl',
        '3 EL heller Essig',
        'Basilikum',
      ],
      steps: [
        'Fusilli nach Packung kochen, kalt abspülen.',
        'Tomaten halbieren, Gurke und Paprika würfeln.',
        'Öl, Essig, Salz und Pfeffer verrühren.',
        'Alles mischen, 10 Minuten ziehen lassen und mit Basilikum bestreuen.',
      ],
      kidsTip: 'Hält im Kühlschrank bis morgen – fürs Pausenbrot.',
    },
    en: {
      title: 'Pasta salad',
      ingredients: [
        '400 g fusilli',
        '250 g cherry tomatoes',
        '1 cucumber',
        '1 pepper',
        '125 g mozzarella balls',
        '4 tbsp olive oil',
        '3 tbsp white vinegar',
        'Basil',
      ],
      steps: [
        'Cook the fusilli as the packet says and rinse under cold water.',
        'Halve the tomatoes and dice the cucumber and pepper.',
        'Whisk the oil, vinegar, salt and pepper.',
        'Mix everything, leave for 10 minutes and sprinkle with basil.',
      ],
      kidsTip: 'Keeps in the fridge until tomorrow – for the lunch box.',
    },
  },
  {
    id: 'couscous-salad',
    minutes: 20,
    tags: ['veggie'],
    de: {
      title: 'Couscous-Salat',
      ingredients: [
        '250 g Couscous',
        '300 ml Gemüsebrühe',
        '1 Gurke',
        '2 Tomaten',
        '1 Paprika',
        '1 Zitrone',
        '3 EL Olivenöl',
        'Petersilie und Minze',
        '100 g Feta',
      ],
      steps: [
        'Couscous mit heißer Brühe übergießen und 5 Minuten quellen lassen, mit einer Gabel auflockern.',
        'Gemüse würfeln, Kräuter hacken.',
        'Zitronensaft und Öl verrühren und alles mischen.',
        'Mit Salz abschmecken und Feta darüberbröseln.',
      ],
      kidsTip: 'Feta und Kräuter extra – so passt es für alle.',
    },
    en: {
      title: 'Couscous salad',
      ingredients: [
        '250 g couscous',
        '300 ml vegetable stock',
        '1 cucumber',
        '2 tomatoes',
        '1 pepper',
        '1 lemon',
        '3 tbsp olive oil',
        'Parsley and mint',
        '100 g feta',
      ],
      steps: [
        'Pour the hot stock over the couscous, leave for 5 minutes and fluff up with a fork.',
        'Dice the vegetables and chop the herbs.',
        'Whisk the lemon juice and oil and mix everything.',
        'Season with salt and crumble the feta over it.',
      ],
      kidsTip: 'Feta and herbs on the side – then it suits everyone.',
    },
  },
  {
    id: 'salmon-tray',
    minutes: 40,
    tags: [],
    de: {
      title: 'Lachs mit Ofengemüse',
      ingredients: [
        '4 Lachsfilets',
        '800 g kleine Kartoffeln',
        '2 Zucchini',
        '250 g Cherrytomaten',
        '1 Zitrone',
        '3 EL Olivenöl',
        'Dill',
      ],
      steps: [
        'Ofen auf 200 °C vorheizen, Kartoffeln halbieren, mit 2 EL Öl und Salz mischen und 20 Minuten backen.',
        'Zucchini in Scheiben schneiden, mit den Tomaten dazulegen.',
        'Lachs dazulegen, mit restlichem Öl beträufeln, salzen und mit Zitronenscheiben belegen.',
        '15 Minuten weiterbacken und mit Dill bestreuen.',
      ],
      kidsTip: 'Lachs ohne Haut kaufen, dann gibt es keine Diskussion.',
    },
    en: {
      title: 'Salmon with roast vegetables',
      ingredients: [
        '4 salmon fillets',
        '800 g small potatoes',
        '2 courgettes',
        '250 g cherry tomatoes',
        '1 lemon',
        '3 tbsp olive oil',
        'Dill',
      ],
      steps: [
        'Heat the oven to 200 °C, halve the potatoes, mix with 2 tbsp oil and salt and bake for 20 minutes.',
        'Slice the courgettes and add them with the tomatoes.',
        'Add the salmon, drizzle with the rest of the oil, season and top with lemon slices.',
        'Bake for another 15 minutes and sprinkle with dill.',
      ],
      kidsTip: 'Buy skinless salmon – no discussion at the table.',
    },
  },
  {
    id: 'fish-lemon-rice',
    minutes: 25,
    tags: [],
    de: {
      title: 'Fischfilet mit Zitronenreis',
      ingredients: [
        '4 Seelachsfilets',
        '250 g Reis',
        '1 Zitrone',
        '2 EL Mehl',
        '2 EL Butter',
        '300 g TK-Erbsen',
        'Petersilie',
      ],
      steps: [
        'Reis nach Packung kochen, Erbsen die letzten 5 Minuten mitgaren.',
        'Fisch salzen, in Mehl wenden und in Butter von jeder Seite 3 Minuten braten.',
        'Abgeriebene Zitronenschale und etwas Saft unter den Reis mischen.',
        'Mit Petersilie und Zitronenspalten servieren.',
      ],
      kidsTip: 'Weißer Fisch ist mild – ein guter Einstieg für Kinder.',
    },
    en: {
      title: 'Fish fillet with lemon rice',
      ingredients: [
        '4 pollock fillets',
        '250 g rice',
        '1 lemon',
        '2 tbsp flour',
        '2 tbsp butter',
        '300 g frozen peas',
        'Parsley',
      ],
      steps: [
        'Cook the rice as the packet says, adding the peas for the last 5 minutes.',
        'Season the fish, coat in flour and fry in the butter for 3 minutes on each side.',
        'Mix grated lemon zest and a little juice into the rice.',
        'Serve with parsley and lemon wedges.',
      ],
      kidsTip: 'White fish is mild – a good start for kids.',
    },
  },
  {
    id: 'chicken-noodle-soup',
    minutes: 45,
    tags: ['kids'],
    de: {
      title: 'Nudelsuppe mit Hähnchen',
      ingredients: [
        '2 Hähnchenbrustfilets',
        '1,5 l Hühnerbrühe',
        '2 Möhren',
        '1 Stange Lauch',
        '2 Stangen Sellerie',
        '150 g Suppennudeln',
        'Petersilie',
      ],
      steps: [
        'Hähnchen in der Brühe 15 Minuten leise garen, herausnehmen und klein zupfen.',
        'Gemüse klein schneiden und 10 Minuten in der Brühe kochen.',
        'Nudeln dazugeben und nach Packung garen.',
        'Hähnchen zurück in die Suppe geben, abschmecken und mit Petersilie servieren.',
      ],
      kidsTip: 'Das Richtige, wenn jemand erkältet ist.',
    },
    en: {
      title: 'Chicken noodle soup',
      ingredients: [
        '2 chicken breasts',
        '1.5 l chicken stock',
        '2 carrots',
        '1 leek',
        '2 sticks celery',
        '150 g soup noodles',
        'Parsley',
      ],
      steps: [
        'Poach the chicken gently in the stock for 15 minutes, take it out and shred it.',
        'Chop the vegetables and cook them in the stock for 10 minutes.',
        'Add the noodles and cook as the packet says.',
        'Return the chicken to the soup, season and serve with parsley.',
      ],
      kidsTip: 'Just right when someone has a cold.',
    },
  },
];
